import { io } from 'socket.io-client';

const SERVER_URL: string =
  process.env.REACT_APP_SERVER_URL || 'http://localhost:8080';
// export const socket = io(SERVER_URL, {
//   withCredentials: true,
//   extraHeaders: {
//     // used in dev environment
//     // @ts-ignore
//     "debugaddress": window.address || "none",
//   }
// });

export const createSocket = (address?: string) => {
  return io(SERVER_URL, {
    withCredentials: true,
    extraHeaders: {
      // used in dev environment
      // @ts-ignore
      debugaddress: address || 'none',
    },
  });
};
